import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AdvancedSideAssetMainContent
	className?: string
}

const ContactUsLocationCard = (props: Props) => {
	return (
		<div className={props.className}>
			<Typography
				content={props.data.title}
				variant={Variant.Title}
				size={Size.M}
			/>
			<Typography
				content={props.data.subtitle}
				variant={Variant.Description}
				size={Size.XS}
			/>
			<ButtonSwitcher buttonsList={props.data} />
		</div>
	)
}

export default ContactUsLocationCard
